import { useRSStore } from '../store/useRSStore'
import { readPkgtypeListAPI, addPkgtypeAPI, updatePkgtypeAPI, deletePkgtypeAPI, paginationPkgtypeAPI } from '../api/PkgtypeAPI'

import type { pkgtype, pagination } from '../types/types'



export function usePkgtype() {
  const RSStore = useRSStore()

  const onReadPkgtypeList = async (pagination: pagination) => {
    try {
      const list = await readPkgtypeListAPI(pagination)
      RSStore.pkgtypeList = list
    } catch (e) {
      console.error("pkgtype 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddPkgtype = async (pkgtypename: string) => {
    try {
      const result = await addPkgtypeAPI(pkgtypename)
      console.log("pkgtype 추가 완료 id:", result)
    } catch (e) {
      console.error("pkgtype 추가 중 에러 발생:", e)
    }
  }

  const onUpdatePkgtype = async (pkgtype: pkgtype) => {
    try {
      const result = await updatePkgtypeAPI(pkgtype)
      if (result) {
        console.log("pkgtype 업데이트 완료 :", pkgtype)
      } else {
        console.log("pkgtype 업데이트 실패 입력값 확인 필요", pkgtype)
      }
    } catch (e) {
      console.error("pkgtype 업데이트 중 에러 발생:", e)
    }
  }

  const onDeletePkgtype = async (id: number) => {
    try {
      const result = await deletePkgtypeAPI(id)
      if (result) {
        console.log("pkgtype 삭제 완료 id:", id)
      } else {
        console.log("pkgtype 삭제 실패 id:", id)
      }
    } catch (e) {
      console.error("pkgtype 삭제 중 에러 발생:", e)
    }
  }

  const onPaginationPkgtype = async (size: number) => {
    try {
      const result = await paginationPkgtypeAPI(size) ?? 0
      return result
    } catch (e) {
      console.error("pkgtype 페이지네이션 중 에러 발생:", e)
    }
  }
  return {
    onReadPkgtypeList,
    onAddPkgtype,
    onUpdatePkgtype,
    onDeletePkgtype,
    onPaginationPkgtype
  }
}